<template>
  <t-block-allow-domain
    v-if="selectedCustomer.id"
    :id="selectedCustomer.id"
    :tier="TIER.domainGroups"
  ></t-block-allow-domain>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

import TBlockAllowDomain from "@/views/Common/TBlockAllowDomain";

import { TIER } from "@/constants/tier";

export default {
  name: "Domains",
  components: {
    TBlockAllowDomain,
  },
  data() {
    return {
      TIER,
    };
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    ...mapActions("modal", ["openModal", "closeModal"]),
  },
  computed: {
    ...mapGetters("authentication", ["selectedCustomer"]),
  },
  mounted() {
    this.setPageTitle(this.$t("Allow & Block List"));
    this.setPageSubtitle([]);
  },
};
</script>
